import { makeZeroArgHook } from "../../utils/makeZeroArgHook";
import getDocuments, { url } from "../requests/getDocuments";
/**
 * Ask Custodian Doc Center to refresh newest documents from the custodian.
 * Should be called at login before the client visits the doc center
 */
const useRequestDocuments = makeZeroArgHook(getDocuments, () => [url()]);
export default useRequestDocuments;
//# sourceMappingURL=useRequestDocuments.js.map